import { Button } from "@/components/ui/button";
import { AlertCircle, Home } from "lucide-react";
import { useLocation } from "wouter";
import Seo from "@/components/Seo";
import { useLocale } from "@/contexts/LocaleContext";

export default function NotFound() {
  const [location, setLocation] = useLocation();
  const { t, locale } = useLocale();

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 text-center px-4">
      <Seo
        title={`404 — ${t("notFound.title")} — Garantías Extraordinarias`}
        description={t("notFound.desc")}
        path={location || "/404"}
        type="website"
        locale={locale}
        noindex
      />
      <AlertCircle className="h-16 w-16 text-gold/40" />
      <h1 className="text-5xl font-serif font-bold text-gold">404</h1>
      <h2 className="text-xl font-semibold text-foreground">{t("notFound.title")}</h2>
      <p className="text-muted-foreground max-w-md">{t("notFound.desc")}</p>
      <Button
        onClick={() => setLocation("/")}
        className="bg-gold text-navy-dark hover:bg-gold-light font-semibold mt-2"
      >
        <Home className="w-4 h-4 mr-2" />
        {t("notFound.home")}
      </Button>
    </div>
  );
}
